@if (displayUrl) {
  <div class="image-input__preview">
    <img [src]="displayUrl" [alt]="previewAlt" />
    <button type="button" class="image-input__remove-button" (click)="removeImage()" [attr.aria-label]="removeLabel">
      <i class="fal fa-trash"></i>
      <span>{{ removeLabel }}</span>
    </button>
  </div>
} @else {
  <label class="image-input__button btn-L btn-filled-alt icon-start">
    <input type="file" class="d-none" [accept]="accept" (change)="selectFileFromInput($event)" />
    <i [class]="iconClass"></i>
    {{ label }}
  </label>
}
